// extracted by mini-css-extract-plugin
module.exports = {"container":"HowItWorksStep_container__jZ6mC","icon":"HowItWorksStep_icon__bVzL_","content":"HowItWorksStep_content__gK4UV","title":"HowItWorksStep_title__4fc6I"};